import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { TemperatureAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';
import { ActionAlertComponent } from '../../action-alert/action-alert.component';

interface TemperatureActionFormGroup {
	temperature: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-temperature-action-controls',
    templateUrl: './temperature-action-controls.component.html',
    styleUrls: ['../../../common.scss', './temperature-action-controls.component.scss'],
    imports: [ReactiveFormsModule, UnitQuantityControl, CommonActionControlsComponent, ActionFormComponent, ActionAlertComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemperatureActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: TemperatureAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as TemperatureAction;
	}

	@Input() form!: FormGroup<TemperatureActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

    ngOnInit(): void {
        this.form.addControl('temperature', this.formBuilder.control(this.action?.temperature ?? null));
    }
}